import authApi from '../../api/auth'
import userApi from '../../api/user'
import router from '../../router'

// initial state
const state = {
  status: '',
  token: '',
  user: {},
}

// getters
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  defaultCalendarRouteName: state =>
    state.user.defaultCalendarView === 'month' ? 'month' : 'calendar',
}

// actions
const actions = {
  requestPasswordReset ({ commit }, email) {
    return new Promise((resolve, reject) => {
      authApi.requestPasswordReset(email, res => {
        console.log(res)
        resolve()
      },
      error => {
        console.log(error)
        reject()
      })
    })
  },

  resetPassword ({ commit }, params) {
    return new Promise((resolve, reject) => {
      authApi.resetPassword(params, res => {
        console.log(res)
        resolve()
      },
      error => {
        console.log(error)
        reject()
      })
    })
  },

  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      authApi.login(user, res => {
        const token = res.jwt
        //const user = res.data.user
        localStorage.setItem('token', token)
        authApi.setHeader(token)

        userApi.getMe(userResponse => {
          const user = userResponse
          commit('auth_success', {token, user})
          resolve(res)
          // what if user isn't found? do we need an error callback?
        })
      },
      error => {
        commit('auth_error')
        localStorage.removeItem('token')
        reject()
      })
    })
  },

  loginAndBecome({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      authApi.loginAndBecome(params, res => {
        const token = res.jwt
        //const user = res.data.user
        localStorage.setItem('token', token)
        authApi.setHeader(token)

        userApi.getMe(userResponse => {
          const user = userResponse
          commit('auth_success', {token, user})
          resolve(res)
          // what if user isn't found? do we need an error callback?
        })
      },
      error => {
        commit('auth_error')
        localStorage.removeItem('token')
        reject()
      })
    })
  },

  // unused i believe
//  register({ commit }, user) {
//    return new Promise((resolve, reject) => {
//      commit('auth_request')
//      authApi.register(user, res => {
//        const token = res.data.token
//        const user = res.data.user
//        localStorage.setItem('token', token)
//
//        authApi.setHeader(token)
//
//        commit('auth_success', { token, user })
//        resolve(res)
//      },
//      error => {
//        commit('auth_error')
//        localStorage.removeItem('token')
//        reject()
//      })
//    })
//  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      authApi.removeHeader()
      router.push('/login')
      resolve()
    })
  },

  setDefaultCalendarView ({ commit, dispatch }, view) {
    return userApi.updateDefaultCalendarView(view)
      .then(response => {
        commit('set_user', response.data)
        dispatch('global/showSnackbarSuccess', { message: 'Default calendar view saved.' }, { root: true })
      })
      .catch(() => {
        dispatch('global/showSnackbarError', { message: 'Could not save your default view.' }, { root: true })
      })
  },

  // TODO: this api call in here is crucial.
  getTokenFromStorage ({ state, commit }) {
    const token = localStorage.getItem('token')
    if (token) {
      commit('setTokenFromStorage', token)
      if (!state.user.id) {
        userApi.getMe(userResponse => {
          const user = userResponse
          commit('auth_success', { token, user })
        })
      } else {
        //console.log('already have user data!')
      }
    } else {
      //console.log('no token in local storage!')
    }
  }

}

// mutations
const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  set_user (state, user) {
    state.user = user
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
    state.user = {}
  },
  setTokenFromStorage (state, token) {
    state.token = token
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
